import { AudioState, AudioTypes } from './types';

export const INITIAL_STATE: AudioState = {
  audioLink: '',
  createdAudioLink: '',
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// Get Audio
const getAudioRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  audioLink: INITIAL_STATE.audioLink,
});

const getAudioSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  audioLink: action.payload.audioLink,
});

const getAudioFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  audioLink: INITIAL_STATE.audioLink,
});

// Create Audio
const createAudioRequest = (state: any, action: any) => ({
  ...state,
  loading: Boolean(action.payload.name),
  error: false,
  createdAudioLink: INITIAL_STATE.createdAudioLink,
});

const createAudioSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  createdAudioLink: action.payload.createdAudioLink,
});

const createAudioFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  createdAudioLink: INITIAL_STATE.createdAudioLink,
});

const reducer = createReducer(INITIAL_STATE, {
  [AudioTypes.GET_AUDIO_REQUEST]: getAudioRequest,
  [AudioTypes.GET_AUDIO_SUCCESS]: getAudioSuccess,
  [AudioTypes.GET_AUDIO_FAILURE]: getAudioFailure,

  [AudioTypes.CREATE_AUDIO_REQUEST]: createAudioRequest,
  [AudioTypes.CREATE_AUDIO_SUCCESS]: createAudioSuccess,
  [AudioTypes.CREATE_AUDIO_FAILURE]: createAudioFailure,
});

export default reducer;
